import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'process-animations-banner',
  templateUrl: './process-animations-banner.component.html',
  styleUrls: ['./process-animations-banner.component.css']
})
export class ProcessAnimationsBannerComponent implements OnInit {
  public loaderPerfilador: any[] = [];

  ngOnInit(): void {
    this.loaderPerfilador = [
      {
        path: './assets/animations/w_1.json',
        autoplay: true,
        loop: true,
        renderer: 'canvas'
      },
      {
        path: './assets/animations/w_2.json',
        autoplay: true,
        loop: true,
        renderer: 'canvas'
      },
      {
        path: './assets/animations/w_3.json',
        autoplay: true,
        loop: true,
        renderer: 'canvas'
      },
      {
        path: './assets/animations/w_4.json',
        autoplay: true,
        loop: true,
        renderer: 'canvas'
      },
      {
        path: './assets/animations/w_5.json',
        autoplay: true,
        loop: true,
        renderer: 'canvas'
      }
    ]
  }

  images = {
    greenLines: './assets/images/green-lines.svg',
  };
}